module.exports = __webpack_public_path__ + "img/93.cb1033df.jpg";